const initialState = {
    data: null,
}
export const storeUserImageReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'STOREUSERIMAGE_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'STOREUSERIMAGE_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        case 'STOREUSERIMAGE_RESET':
            return initialState;
        default:
            return state;
    }
}

export default storeUserImageReducer; 